import { useState } from "react";
import { GetRawSizeByModel } from "../services/GetRawSizeByModel";
import { RawSizes } from "../models/app";

interface ApiResponse<T> {
  Data: T;
}

export const useGetRawSize = () => {
  const [rawSizes, setRawSizes] = useState<RawSizes[]>([]);
  const [rawSizesLoading, setLoading] = useState(false);
  const [rawSizesError, setError] = useState<string | null>(null);

  const getRawSizes = async (brand?: string, model?: string) => {
    try {
      setLoading(true);
      setError(null);

      const response = await GetRawSizeByModel(brand, model);

      // response IS the array
      setRawSizes(response as RawSizes[]);
    } catch (err) {
      console.error(err);
      setError("Error fetching raw sizes");
      setRawSizes([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    getRawSizes,
    rawSizes,
    rawSizesLoading,
    rawSizesError,
  };
};
